import React from 'react';
import { formatDate } from '../../../data/utils/formatDate';
import { oddToString } from '../../../data/utils/oddToString';
import { getLabel } from '../../../data/labels';

function PlainTicketSelections(props) {
	const ticketData = props.ticketData;
    const psvVincPiazzSports = props.psvVincPiazzSports;
    const vincPiazzByProviderAndSport = psvVincPiazzSports?.vincPiazzByProviderAndSport;
	// const frontendType = props.frontendType;
	// const aamsEnviroment = props.aamsEnviroment;
	const selections = ticketData.events;
	const purchaseType = ticketData.purchaseType;
	const conf = props.conf;
	
	const baseSymb = getLabel('ticket.system.base_symb');
	const varSymb = getLabel('ticket.system.var_symb');
	let systemLegenda = baseSymb + " = " + getLabel('ticket.system.base') + '; ';
	systemLegenda += varSymb + " = " + getLabel('ticket.system.variable') + '; ';
	systemLegenda += "* = " + getLabel('ticket.system.in_bonus');
	
	
	let liveSymbol = getLabel('ticket.live_symbol').length > 0 ? '[' + (getLabel('ticket.live_symbol') + '] ') : null;
	if (!liveSymbol && getLabel('general.live').length > 0) {
		const liveLabel = getLabel('general.live');
		if (liveLabel.length > 0) {
			liveSymbol = ['[', liveLabel.charAt(0).toUpperCase(), ']', ' '].join('');
		}
	}
	
	if(!liveSymbol){
		liveSymbol = '[L] ';
	}
	const clearBoth = {clear: "both"};

	return (
        <>
            {selections.map(function(selection) {
                let uniqueId = selection.alias;
                const prvSpId = selection.psvProvider+'_'+selection.sportId;
                const printPalAvv = (!uniqueId || uniqueId.length === 0) || conf.ppat;
                if (printPalAvv) {
                    uniqueId = selection.pal + "." + selection.avv;
                }
                let descManif = ''
                
                if (selection.descSport != null && selection.descSport.length > 0) {
                    if(selection.psvPlatformDesc){
                        descManif = selection.psvPlatformDesc + " ";
                    }
                    descManif += selection.descSport;
                }
                if (selection.descCategory != null && selection.descCategory.length > 0) {
                    descManif = descManif + " " + selection.descCategory;
                }
                if (selection.descTournament != null && selection.descTournament.length > 0) {
                    descManif = descManif + " " + selection.descTournament;
                }
                
                const banker = purchaseType === 'systembets' ? (selection.fixed? baseSymb : varSymb) : '';
                
                const reactKey = 'ticket-selection-' + selection.pal + "-" + selection.avv;
                const bets = selection.bets;
                const eventDate = formatDate(selection.timestamp).formatted;
                return (
                    <div key={reactKey} className="event">
                        <div className="tournament_row">
                            <div className="banker left">{banker}</div>
                            <div className="palavv left">{uniqueId}</div>
                            <div className="tournament_descr truncate_tournament_descr left">{descManif}</div>
                            <div style={clearBoth}></div>
                        </div>
                        <div className="event_row">
                        <div className="date_event">{eventDate}</div>
                        <div className="event_descr truncate_event_descr bold">
                            {conf.plit && selection.liveWhilePurchase? liveSymbol: "" }{selection.descAvv}
                        </div>
                        <div style={clearBoth}></div>
                        </div>
                        <div className="bets">
                            {bets.map(function(bet) {
                                const printNumber = vincPiazzByProviderAndSport?.[prvSpId]?.isVincente(bet.scomSogei) ||   vincPiazzByProviderAndSport?.[prvSpId]?.isPiazzato2(bet.scomSogei) ||  vincPiazzByProviderAndSport?.[prvSpId]?.isPiazzato3(bet.scomSogei);
                                const betReactKey = reactKey + '-bet-' + bet.scomSogei + '-' + bet.handicap + '-' + bet.codDraw;
                                const odd = oddToString(bet.odd);
                                return (
                                    <div key={betReactKey} className="bet">
                                        <div className="td-60 left bet_descr uppercase">{bet.printableDescScom}</div>
                                        <div className="td-25 left draw_descr uppercase">{printNumber?(bet.codDraw+'-'):''}{bet.printableDescDraw}</div>
                                        <div className="td-15 left odd textright bold">{odd}</div>
                                        <div style={clearBoth}></div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                );
            })}
            {purchaseType === 'systembets' &&
                <>
                    <div className="separator"></div>
                    <div>{systemLegenda}</div>
                </>
            }
        </>
    );
}

export default PlainTicketSelections;